import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { PageContainer } from "../../components/PageContainer";
import { setCollectionYardVisitEventsVisitId } from "../../reducers/collectionYardVisitEventsReducer";
import { MayorModulesType } from "../../types/mayorModules";
import { BannersComponent } from "./BannersComponent";
import { CollectionYardVisitEventsPageHeaderComponent } from "./CollectionYardVisitEventsPageHeaderComponent";
import { CollectionYardVisitEventsTable } from "./CollectionYardVisitEventsTable";

import styles from "./CollectionYardVisitEventsPage.module.scss";

export const CollectionYardVisitEventsPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = window.location;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const visitId = Number(params.get("cyvid"));
    if (visitId) {
      dispatch(setCollectionYardVisitEventsVisitId(visitId));
    }
  }, [location.search, dispatch]);

  return (
    <PageContainer
      HeaderComponent={CollectionYardVisitEventsPageHeaderComponent}
      module={MayorModulesType.CollectionPointModule}
    >
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <BannersComponent />
          <br />
          <h4 className={styles.tableHeaderTitle}>{t("collectionYardVisitEvents.tableTitle")}</h4>
          <CollectionYardVisitEventsTable />
        </div>
      </div>
    </PageContainer>
  );
};
